/**
 * Eligibility 5012 — KUK eligibility criteria.
 *
 * A heading above a single tinted panel carrying the entry requirement and an
 * optional note. Ported from kuk-campus-portal's
 * `components/Landing/Eligibility.tsx`.
 *
 * Every field maps to a column that already exists on `eligibility` — the
 * variant adds no schema of its own beyond widening `eligibility.variant`.
 *
 * COLUMN MAPPING — `eligibility` has one description column, so the note is
 * stored in `read_more_text` / `read_more_color`. Those names are historical;
 * nothing here renders a "read more" link.
 */

export const ELIGIBILITY_5012_CONSTANTS = {
  ELIGIBILITY_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Eligibility Criteria",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Eligibility Criteria",
      required: false,
      defaultValue: "Eligibility Criteria",
    },
    {
      fieldName: "title_text_color",
      label: "Heading colour",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#101112",
      required: false,
      defaultValue: "#101112",
    },
    {
      fieldName: "description",
      label: "Criteria",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      rows: 3,
      placeholder: "e.g. A bachelor's graduate from any recognized university",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_text_color",
      label: "Criteria colour",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#101112",
      required: false,
      defaultValue: "#101112",
    },
    {
      fieldName: "read_more_text",
      label: "Additional note",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      rows: 3,
      placeholder: "Optional second line under the criteria",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "read_more_color",
      label: "Additional note colour",
      value: "#4B4B4B",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#4B4B4B",
      required: false,
      defaultValue: "#4B4B4B",
    },
    {
      fieldName: "category_border_color",
      label: "Panel border colour",
      value: "#E2E8F0",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E2E8F0",
      description: "The reference's card border (slate-200).",
      defaultValue: "#E2E8F0",
    },
    {
      fieldName: "background_color",
      label: "Panel fill",
      value: "rgba(159, 28, 51, 0.10)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(159, 28, 51, 0.10)",
      description: "RGBA, not COLOR: the reference tints the panel with its brand colour at 10%.",
      required: false,
      defaultValue: "rgba(159, 28, 51, 0.10)",
    },
    {
      fieldName: "button_icon",
      label: "Leading icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload an icon, or type an icon name",
      description: "Accepts an uploaded image URL OR a built-in icon name such as user.",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_icon_alt",
      label: "Leading icon alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_color",
      label: "Leading icon colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#9F1C33",
      required: false,
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: true,
    },
  ],
};
